import React from 'react';
import { getLatestVisitAllProspects } from 'api/textVisit';
import { Prospect } from 'types/common';

let globalData: Prospect[] = [];

const useGetLatestVisitAllProspects = (): [Prospect[], boolean, () => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<Prospect[]>(globalData);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await getLatestVisitAllProspects();
            if (!result.error) {
                const data: Prospect[] = result?.data?.data;
                globalData = data;
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current) {
            fetchData();
        }
    }, []);

    return [items, loading.current, fetchData];
};

export default useGetLatestVisitAllProspects;
